import React from "react";
import TaskListIndex from "../../components/TaskList/TaskListIndex";
import "./DailyTasks.css";

function TaskList() {
  return (
    <div className="task-list-page">
      <TaskListIndex />
    </div>
  );
}

export default TaskList;